import React, { Component } from 'react';
import update from 'immutability-helper';
import NamezzzUploads from '../../Fields/NamezzzUploads.js';
import Loading from '../Loading.js'
import Reloading from '../Reloading.js';
import { getPersonAttachments, deletePersonAttachments } from '../../Api/UserActions.js'
import { getJsonItem, getDateString, getJsonDate } from '../../Utilities/JsonFunctions.js'
import { getTranslation } from '../../Utilities/GetTranslation.js'

declare var globalSns;

class Uploads extends Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.loadData = this.loadData.bind(this);
        this.onOverride = this.onOverride.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    // Load or reload the attachments
    loadData() {
        getPersonAttachments(globalSns.languageId, globalSns.jobId, (data) => {
            this.setState({
                personAttachments: data
            });
            this.setState({
                reloading: false
            });
        });
    }

    reloadData = () => {
        this.setState({
            reloading: true
        });
        this.loadData();
    }

    async isValidated() {
        // Show warning, which can be overriden, when there are no uploads
        if (!this.state.doOverride && (this.state.personAttachments == null || this.state.personAttachments.length === 0)) {
            this.setState({
                showOverride: true
            });
            return false;
        }

        return true
    }

    onOverride() {
        this.setState({
            doOverride: true
        }, () => this.props.onGoNext()
        );
    }

    onPersonAttachmentDelete(id, historyId, e) {
        deletePersonAttachments(id, historyId, () => {
            var item = getJsonItem(this.state.personAttachments, "id", id);
            var index = this.state.personAttachments.indexOf(item);

            this.setState({
                personAttachments: update(this.state.personAttachments, {$splice: [[index, 1]]})
            })
        });
    }

    render() {

        if (this.state.personAttachments == null) {
            return (
                <Loading/>
            );
        }

        // Intro text for uploads; business registrations always have a default text
        let appTextUpload = (this.props.job.appTextUpload === "") ? "" : <p><em dangerouslySetInnerHTML={{ __html: this.props.job.appTextUpload}} /></p>;  
        if (this.props.job.isBusinessRegistration && appTextUpload === "") {
            appTextUpload = <p><em>{getTranslation("sns.webparts.uploads.sub")}</em></p>
        }
      
        return (
            <div>
                {
                    (this.props.job.isBusinessRegistration) ? "" : <h4 className="legend-title">{getTranslation("sns.webparts.motivation.uploads")}</h4>
                }
                {appTextUpload}
                {
                    (this.state.personAttachments.length > 0) ?
                        <div className="tr table-wrapper userdata">
                            <strong>{getTranslation("sns.webparts.uploads.documents")}</strong>
                            <table className="table table-condensed table-responsive">
                                <tbody>
                                    {
                                        this.state.personAttachments.map((personAttachment) => 
                                            <tr key={personAttachment.id}>
                                                <td>{getDateString(getJsonDate(personAttachment.creDat))}</td>
                                                <td>{personAttachment.category}</td>
                                                <td><a href={personAttachment.url} target="_blank">{personAttachment.name}</a></td>
                                                <td><a href="# " className="file" onClick={(e) => this.onPersonAttachmentDelete(personAttachment.id, personAttachment.historyId, e)}><span className="sr-only">{getTranslation("sns.general.screenreader.delete")}</span><i className="fa fa-trash-o" aria-hidden="true"></i></a></td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div> :
                        ""
                }
                {
                    (this.state.showOverride) ? 
                        <div className="tr">
                            <div className="td col-md-8">
                                <span className="EditingFormErrorLabel">
                                    {getTranslation("sns.webparts.uploads.noupload")}
                                </span>                            
                                <input id="doOverride" type="button" 
                                    className="FormButton btn btn-primary blue act" 
                                    value={getTranslation("sns.webparts.uploads.noupload.overrule")} 
                                    autoFocus
                                    onClick={this.onOverride} />
                            </div>
                        </div> : ""
                }
                {
                    this.state.reloading ? (<Reloading />) : ""
                }               
                <NamezzzUploads jobId={globalSns.jobId} onFileUploadsSaved={this.reloadData} />
            </div>
        );
    }
}

export default Uploads;


// WEBPACK FOOTER //
// ./src/Components/Tabs/Uploads.js